import { render, staticRenderFns } from "./CollectionStatement.vue?vue&type=template&id=6f73d5c2&scoped=true&"
import script from "./CollectionStatement.vue?vue&type=script&lang=ts&"
export * from "./CollectionStatement.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionStatement.vue?vue&type=style&index=0&id=6f73d5c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73d5c2",
  null
  
)

export default component.exports